import React, { useState } from "react";
import {
  Box,
  ImageList,
  ImageListItem,
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// ✅ Accept images as a prop for reusability
export default function Gallery({ images }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = (img) => {
    setSelected(img);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ p: 2 }}>
      <ImageList variant="masonry" cols={isSmall ? 2 : 3} gap={8}>
        {images.map((item, index) => {
          const isExternal = item.img.startsWith("http");
          const src = isExternal
            ? `${item.img}&w=600&fit=crop&auto=format`
            : item.img;
          const srcSet = isExternal
            ? `${item.img}&w=600&fit=crop&auto=format&dpr=2 2x`
            : undefined;
          return (
            <ImageListItem key={index} onClick={() => handleOpen(item.img)}>
              <img
                src={src}
                srcSet={srcSet}
                alt={item.title}
                loading="lazy"
                style={{ cursor: "pointer", borderRadius: "8px" }}
              />
            </ImageListItem>
          );
        })}
      </ImageList>

      <Dialog open={open} onClose={handleClose} maxWidth="lg">
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "white",
            backgroundColor: "rgba(0,0,0,0.3)",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ p: 0 }}>
          {selected && (
            <img
              src={selected}
              alt="Selected"
              style={{ width: "100%", height: "auto" }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
